<template>
  <Transition name="fade">
    <div
      v-if="visible"
      class="fixed bottom-6 right-6 z-50 max-w-sm w-full p-5 bg-white text-black rounded-2xl shadow-xl border border-gray-200"
    >
      <div class="flex justify-between items-start mb-3">
        <h3 class="text-lg font-semibold">
          {{ $t("newsletter.title") }}
        </h3>
        <button class="text-gray-400 hover:text-black" @click="close">×</button>
      </div>

      <form class="space-y-3" @submit.prevent="subscribe">
        <input
          v-model="email"
          type="email"
          :placeholder="$t('newsletter.placeholder')"
          class="w-full px-4 py-2 rounded border border-gray-300"
          required
        />
        <button
          type="submit"
          class="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded"
        >
          {{ $t("newsletter.subscribe") }}
        </button>
        <p v-if="message" class="text-sm text-center">{{ message }}</p>
      </form>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useSupabaseClient, useI18n } from "#imports";

const { t } = useI18n();
const visible = ref(false);
const email = ref("");
const message = ref("");
const supabase = useSupabaseClient();

onMounted(() => {
  if (!localStorage.getItem("newsletterClosed")) {
    setTimeout(() => {
      visible.value = true;
    }, 4000);
  }
});

const subscribe = async () => {
  const { error } = await supabase
    .from("newsletter_subscribers")
    .insert({ email: email.value });

  if (error) {
    message.value = t("newsletter.already");
  } else {
    message.value = t("newsletter.success");
    setTimeout(() => close(), 2000);
  }
  email.value = "";
};

const close = () => {
  visible.value = false;
  localStorage.setItem("newsletterClosed", "1");
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
